import { CastContext, CastSession, CastSessionStatus } from '../interfaces';
import { getChrome } from './getters';

export function getLocalSessionId() {
  return localStorage.getItem('cast_session_id');
}

export function setLocalSessionId(sessionId: string) {
  localStorage.setItem('cast_session_id', sessionId);
}

export function removeLocalSessionId() {
  localStorage.removeItem('cast_session_id');
}

export function getSession(context: CastContext | undefined): CastSession | undefined {
  const currentSession = context?.getCurrentSession();

  if (currentSession) {
    return currentSession;
  }

  const sessionId = localStorage.getItem('cast_session_id');

  if (sessionId !== null) {
    try {
      const chrome = getChrome();
      chrome?.cast.requestSessionById(sessionId);
    } catch {
      // RIP chromecast :(
    }
  }

  const session = context?.getCurrentSession();

  if (session) {
    localStorage.setItem('cast_session_id', session.getSessionId());
    return session;
  }

  return undefined;
}

export function getCastStatus(state: cast.framework.SessionState): CastSessionStatus {
  switch (state) {
    case cast.framework.SessionState.SESSION_STARTING:
      return 'pending';
    case cast.framework.SessionState.SESSION_STARTED:
    case cast.framework.SessionState.SESSION_RESUMED:
      return 'connected';
    case cast.framework.SessionState.SESSION_ENDING:
    case cast.framework.SessionState.SESSION_ENDED:
    case cast.framework.SessionState.SESSION_START_FAILED:
      return 'disconnected';
    default:
      return 'pending';
  }
}

export function getInitialCastStatus(session: CastSession | undefined): CastSessionStatus {
  return session ? getCastStatus(session.getSessionState()) : 'pending';
}
